import { clamp } from 'lodash';
import { Amplitudes } from '../../ecg/types/signal';
import { argMin, argMax, getLinSpace } from '../../utils/math';
import { Wave } from '../../wave/types/wave.type';
import { isWaveOfType } from '../../wave/utils/wave.util';
import { ms2ind, ind2ms, getTimeAmplitudes } from './signal.utils';

export const getWaveMinMaxTimeValues = (
  wave: Wave,
  signal: Amplitudes,
  frequency: number,
) => {
  const [onsetIndex, offsetIndex] = [
    ms2ind(wave.onset, frequency),
    ms2ind(wave.offset, frequency),
  ];

  const chunk = signal.slice(onsetIndex, offsetIndex + 1);
  const combinations = {
    min: argMin(chunk),
    max: argMax(chunk),
  };
  if (isWaveOfType(wave, 'P')) {
    const linearSpacedChunk = getLinSpace(
      chunk[0],
      chunk[chunk.length - 1],
      chunk.length,
    );
    const correctedChunk = chunk.map((item, i) => item - linearSpacedChunk[i]);
    combinations.min = argMin(correctedChunk);
    combinations.max = argMax(correctedChunk);
  }

  const [minTimeMs, maxTimeMs] = [
    ind2ms(onsetIndex + combinations.min, frequency),
    ind2ms(onsetIndex + combinations.max, frequency),
  ];

  const clampedMinTime = clamp(minTimeMs, wave.onset, wave.offset);
  const clampedMaxTime = clamp(maxTimeMs, wave.onset, wave.offset);

  return getTimeAmplitudes([clampedMinTime, clampedMaxTime], signal, frequency);
};
